import { Link } from 'react-router-dom';
import { faHandshake, faPeopleArrows, faComments, } from '@fortawesome/free-solid-svg-icons';
import DevLogButton from '../../components/DevLogButton';
import ShareButton from '../../components/ShareButton';

const nextSteps = [{
    icon: faHandshake,
    title: 'Enter the Beta',
    subtitle: 'Early Access. Exclusive Rewards. Impact.',
    description: 'Be part of Spitface Battles from the start. Step up, claim your place, and experience the platform before anyone else. Influence features, guide the community, and make your presence felt across the scene.',
    bulletPoints: [
        'Lifetime Premium',
        'Permanent Recognition',
        'Beta Access'
    ],
    CallToAction: ({ handleOnClick, className = '' }) => <Link to="/beta-roles" onClick={handleOnClick} className={className}>Pick Your Role</Link>
}, {
    icon: faComments,
    title: 'Track the Build',
    description: 'Follow progress as beta development moves forward.',
    CallToAction: ({ className = '' }) => <DevLogButton className={className} />
}, {
    icon: faPeopleArrows,
    title: 'Share the Beta',
    description: 'Invite battlers, judges, and fans to help grow Spitface Battles.',
    CallToAction: ({ className = '' }) => <ShareButton className={className} />
}];

export default nextSteps;